import React from "react";
import EventStore from '@stores/EventStore';
import { reaction, observable } from 'mobx';
import { observer } from 'mobx-react';
import PageHeader from '@components/PageHeader';
import PageFooter from '@components/PageFooter';
import SignatureCapture from '@components/SignatureCapture';
import SignatureStore from '@stores/SignatureStore';
import utils from '@utils/utils';

@observer
export default class GenericSignaturePage extends React.Component {
    @observable signatureSubmitted = false;
    @observable bodyText;
    @observable headerTitle;
    @observable signatureMessage;

    constructor() {
        super();

        this.setupPage();
    }

    setupPage = () => {
        this.signatureSubmitted = false;
        this.bodyText = '';
        this.headerTitle = '';
        this.signatureMessage = '';

        if(EventStore.eventObj.payload.agreementData) {
            this.bodyText = EventStore.eventObj.payload.agreementData;
            this.headerTitle = EventStore.eventObj.payload.headerTitle;
        }
    }

    endReaction = reaction(() => EventStore.eventObj, () => {
        if(EventStore.eventObj.event === 'pageNavigation' && EventStore.eventObj.payload.pageName === 'signatureCapture') {
            this.setupPage();
        }
    });

    submitSignature = (sig) => {
        SignatureStore.submitSignature(sig.slice(22))
        .then(function() {
            this.signatureMessage = 'Signature has been processed.';
            this.signatureSubmitted = true;
        }.bind(this))
        .catch(function(error) {
            this.signatureMessage = error.message || "Error Occured.";
            this.signatureSubmitted = true;
        }.bind(this))
    }

    render() {
        return (
            <div>
                <PageHeader title={this.headerTitle}/>
                <div className="center">
                    <div dangerouslySetInnerHTML={{__html: this.bodyText}} />
                    { this.signatureSubmitted ? 
                        (<h2 className="margin-top-50 center">{this.signatureMessage}</h2>) :
                        (<SignatureCapture sigID="signature" submitSig={this.submitSignature}/>)
                    }
                </div>
                <PageFooter />
            </div>
        );
    }

    componentWillUnmount() {
        this.endReaction();
    }
}


// WEBPACK FOOTER //
// ./src/js/pages/GenericSignaturePage.js